import ConfigMixin from '../../../../mixins/config'
import props from './props'
const EventBus = window.VueEventBus

import LanguageMixin from '../../../../mixins/lang'
import SettingsMixin from '../../../../mixins/settings'
const mixins = [ConfigMixin, LanguageMixin, SettingsMixin]

export default {
  name: 're-profile-cards',
  mixins,
  props,

  data() {
    return {
      showAddModal: false,
      showAddedSuccessModal: false,
      showArchiveSuccessModal: false,
      showInfoModal: false,
      isNumberInfo: false,
      showResendModal: false,
    }
  },

  computed: {
    infoTitle() {
      return this.isNumberInfo ?  this.numberInfoModalTitle : this.codeInfoModalTitle
    },
    infoHeaderText() {
      return this.isNumberInfo ? this.numberInfoModalHeader : this.codeInfoModalHeader
    },
    infoFooterText() {
      return this.isNumberInfo ? this.numberInfoModalFooter : this.codeInfoModalFooter
    },
    infoImgSrc() {
      return this.isNumberInfo ? this.numberInfoModalImgSrc : this.codeInfoModalImgSrc
    },
    hasCards() {
      return !_.isEmpty(this.cardsList)
    },
    cardTabs() {
      if (!_.isEmpty(this.tabs)) {
        return this.tabs
      }
      return {
        'allCards': {
          hideTitle: true,
          title: 'Cards',
          active: true,
          cards: this.cardsList
        }
      }
    },
    hasTabs() {
      return !_.isEmpty(this.cardTabs)
    },
    cards() {
      return this.cardsList
    },
    addCardAttr() {
      return _.pickBy({
        classes: this.addCardClass,//@fix
        title: this.addCardTitle, //@fix
        showTitle: this.addCardShowTitle, //@added
        isProcessing: this.isProcessingAddCard,
        addingMessage: this.addingMessage, //@fix
        errorMessage: this.addingErrorMessage,

        numberLabel: this.addCardNumberLabel, //@fix
        numberPlaceholder: this.addCardNumberPlaceholder, //@fix
        numberClasses: this.addCardNumberClass, //@fix
        codeLabel: this.addCardCodeLabel, //@fix
        codePlaceholder: this.addCardCodePlaceholder, //@fix
        codeClasses: this.addCardCodeClass, //@fix

        buttonTitle: this.addCardButtonTitle,
        buttonClasses: this.addCardButtonClass,//@fix
        showCancelButton: this.addCardShowCancelButton,//@fix
        cancelButtonTitle: this.addCardCancelButtonTitle, //@fix
        cancelButtonClasses: this.addCardCancelButtonClass, //@fix

        hasResendCode: this.addCardHasResendCode, //@fix
        resendCodeMessage: this.addCardResendCodeMessage, //@fix
        resendCodeLinkLabel: this.addCardResendCodeLinkLabel, //@fix

        hasHelpNumberLink: this.addCardHasHelpNumberLink, //@fix
        helpNumberLinkLabel: this.addCardHelpNumberLinkLabel, //@fix

        hasHelpCodeLink: this.addCardHasHelpCodeLink, //@fix
        helpCodeLinkLabel: this.addCardHelpCodeLinkLabel, //@fix
      }, i => !_.isNil(i))
    }
  },

  async created() {
    this.registerEventListeners()
  },

  methods: {
    getCardAttr(card) {
      return {
        card: card,
        cardType: card.type || this.cardType,
        showImage: this.showProductImage,
        imageClass: this.productImageClasses,
        modalClasses: this.modalClasses,

        purchaseLink: this.purchaseCardButtonLink,
        reloadRoute: this.reloadCardRoute,
        reloadType: this.reloadCardType,
      }
    },
    getCardTranslations() {
      return this.$$t('card', this.$$t('cardItem', this.$$t('component.card')))
    },
    getCardSettings() {
      return this.$$s('card', this.$$s('cardItem', this.$$s('component.card')))
    },
    registerEventListeners() {
      EventBus.$on('giftcard.archived', card => {
        this.showArchiveSuccessModal = true
      })
      EventBus.$on('playcard.archived', card => {
        this.showArchiveSuccessModal = true
      })

      EventBus.$on('card.open.resend.code', () => {
        this.showResendModal = true
      })
      EventBus.$on('card.open.info.number', () => {
        this.showInfoModal = true
        this.isNumberInfo = true
      })
      EventBus.$on('card.open.info.code', () => {
        this.showInfoModal = true
        this.isNumberInfo = false
      })
      EventBus.$on('card.added', () => {
        this.showAddModal = false
        this.showAddedSuccessModal = true
      })
    },

    addCard(fields) {
      this.$emit('addCard', fields)
    },

    openAddCardModal() {
      this.showAddedSuccessModal = false
      this.showAddModal = true
    },
    closeAddCardModal() {
      this.showAddModal = false
    },
    closeInfoModal() {
      this.showInfoModal = false
      this.isNumberInfo = false
    },
    closeResendModal() {
      this.showResendModal = false
      this.recoverSuccess = false
    },
    recoverByEmail(payload) {
      this.$emit('recoverByEmail', payload)
    },
    recoverByNumber(payload) {
      this.$emit('recoverByNumber', payload)
    }
  },
}
